import { render, staticRenderFns } from "./LabelYIcon.vue?vue&type=template&id=01fff000&"
import script from "./LabelYIcon.vue?vue&type=script&lang=js&"
export * from "./LabelYIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports